<script>
    import eventProxyMixin from "../../../../Components/DragAndDrop/Mixins/eventProxy";
    import permissionsMixin from '../../Mixins/journey-permissions'

    import LoadingBox from "../../../../Components/Util/LoadingBox.vue";
    import DragAndDropDraggable from "../../../../Components/DragAndDrop/DragAndDropDraggable.vue";
    
    export default {
        name: 'journey-builder-composer-draggable',
        mixins: [eventProxyMixin, permissionsMixin],
        render(createElement, context) {
            const vm = this;
            
            //Triggering a full re-render causes things to break
            //hold off with our actual component rendering until we know which component to render
            if(!vm.canRender){
                return createElement(LoadingBox);
            }
            
            //Drag and Drop should be disabled when a user can't edit the current journey
            if(!vm.canWrite){
                return vm.$slots.default;
            }
            
            return createElement(DragAndDropDraggable, {
                class: 'draggable',
                props: vm.$props,
                on: {
                    start: this.createEventProxy('start'),
                    stop: this.createEventProxy('stop'),
                    drag: this.createEventProxy('drag')
                }
            }, [vm.$slots.default]);
        },
        watch: {
            hasWritePermission(){
                this.writePermissionValidated = true;
            },
            hasSpecialWritePermission(){
                this.specialWritePermissionValidated = true;
            }
        },
        computed: {
            canRender(){
                return this.writePermissionValidated && this.specialWritePermissionValidated;
            }
        },
        data: () => ({
            writePermissionValidated: false,
            specialWritePermissionValidated: false
        }),
        props: {
            jsPlumbInstance: {
                type: Object,
                required: true
            },
            containment: {
                type: Boolean,
                required: false
            }
        }
    }
</script>

<style scoped>
    * {
        position: absolute;
    }
    
    :not(.draggable) {
        /* Prevent our cursor from tricking the user into thinking the element is draggable */
        cursor: auto !important;
    }
</style>